import { render, staticRenderFns } from "./DrugHandoverEdit.vue?vue&type=template&id=f478e172&scoped=true"
import script from "./DrugHandoverEdit.vue?vue&type=script&lang=js"
export * from "./DrugHandoverEdit.vue?vue&type=script&lang=js"
import style0 from "./DrugHandoverEdit.vue?vue&type=style&index=0&id=f478e172&prod&lang=css"
import style1 from "./DrugHandoverEdit.vue?vue&type=style&index=1&id=f478e172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f478e172",
  null
  
)

export default component.exports